<template>
  <div v-if="Town">
    <HeaderYellow
      anteTitle="Formations de qualité"
      :title="`Devenez Chauffeur VTC à ${Town.town}`"
      postTitle="Rejoignez notre Institut et lancez votre carrière de chauffeur VTC."
      :backgroundImage="require('@/assets/pictures/taxi-vtc.webp')"
    />
    <CreationRead
      :town="Town"
      :backgroundImage="require('@/assets/pictures/taxi-vtc.webp')"
      :key="townKey"
    />
  </div>
</template>

<script>
import CreationRead from "@/components/plugins/CreationRead.vue";
import HeaderYellow from "@/components/headers/HeaderYellow.vue";
import { mapGetters, mapActions } from "vuex";
//import { useMeta } from "vue-meta";
export default {
  name: "CreationTownView",
  components: { CreationRead, HeaderYellow },
  created() {
    const id = this.$route.params.id;
    this.$store.dispatch("GetTown", id);
  },

  data() {
    return {
      form: {
        content: "",
        article: "",
      },
      formVisible: false,
      showError: false,
      townKey: 0,
    };
  },
  computed: {
    ...mapGetters({
      Token: "StateToken",
      User: "StateUser",
      Town: "StateTown",
    }),
    isLoggedIn: function () {
      return this.$store.getters.isAuthenticated;
    },
  },
  watch: {
    Town: {
      handler(newVal, oldVal) {
        // Vérifie si Town a effectivement changé
        if (newVal && newVal !== oldVal) {
          this.townKey += 1; // Change la clé pour forcer le re-rendu de TownRead
        }
      },
      deep: true, // Assure que les changements profonds sont détectés
    },
  },
  methods: {
    ...mapActions(["GetTowns", "GetTown"]),
  },
};
</script>
